import { render, staticRenderFns } from "./discoverClid.vue?vue&type=template&id=05a81a8a&scoped=true&"
import script from "./discoverClid.vue?vue&type=script&lang=js&"
export * from "./discoverClid.vue?vue&type=script&lang=js&"
import style0 from "./discoverClid.vue?vue&type=style&index=0&id=05a81a8a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05a81a8a",
  null
  
)

export default component.exports